import {FC} from 'react'
import {useIntl} from 'react-intl'
import {Toolbar2} from '../../../../../../_metronic/layout/components/toolbar/Toolbar2'
import {PageTitle} from '../../../../../../_metronic/layout/core'
import {Vertical} from './components/Vertical'

const AddContracts: FC = () => {
  const intl = useIntl()

  return (
    <>
      <Toolbar2 icon={false} subtitle={intl.formatMessage({id: 'COMMON.BACK_BUTTON'})} />
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'CONTRACTS.ADD_BUTTON'})}</PageTitle>
      <Vertical />
    </>
  )
}

export {AddContracts}
